import { api } from './networkService';

class ReportService {
    static async fetchProfit(filters) {
        try {
            const response = await api.get(`api/user/report/profit`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch report error:', error);
            throw error;
        }
    }

    static async fetchMonthlyProfit() {
        try {
            const response = await api.get(`api/user/report/monthly-profit`);
            return response.data;
        } catch (error) {
            console.error('Fetch report error:', error);
            throw error;
        }
    }

    static async fetchMoneyMovemenets(filters) {
        try {
            const response = await api.get(`api/user/report/money-movements`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch report error:', error);
            throw error;
        }
    }

    static async fetchActivity(filters) {
        try {
            const response = await api.get(`api/user/report/total-activity`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch report error:', error);
            throw error;
        }
    }

    static async fetchRemaining(filters) {
        try {
            const response = await api.get(`api/user/report/total-remaining`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch report error:', error);
            throw error;
        }
    }
}

export default ReportService;
